import { Field } from 'formik';
import { Col, Form, Row, Stack } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../../components/forms';
import { NumberInput } from '../../../../../../components/inputs/NumberInput';
import { StepProps } from '../AddEditRecipe';

export const RecipeStatsForm = ({
  touched,
  errors,
  values,
  setFieldValue,
  readOnly
}: StepProps) => {
  return (
    <Row>
      <Col xs={12}>
        <FormStepHeader title="Recipe Stats" showRequiredLegend={false} />
      </Col>
      <Col
        xs={12}
        lg={6}
      >
        <Stack gap={3}>
          {/* Cook Time  */}
          <Form.Group controlId="cook_time">
            <FormLabel>Cook time</FormLabel>
            <Field
              name="cook_time"
              as={NumberInput}
              isInvalid={touched.cook_time && !!errors.cook_time}
              disabled={readOnly}
            />
          </Form.Group>
          {/* Prep time */}
          <Form.Group controlId="prep_time">
            <FormLabel>Prep time</FormLabel>
            <Field
              name="prep_time"
              as={NumberInput}
              isInvalid={touched.prep_time && !!errors.prep_time}
              disabled={readOnly}
            />
          </Form.Group>
        </Stack>
      </Col>
      <Col
        xs={12}
        lg={6}
      >
        <Stack gap={3}>
          {/* Min served */}
          <Form.Group controlId="min_served">
            <FormLabel>Min served</FormLabel>
            <Field
              name="min_served"
              as={NumberInput}
              isInvalid={touched.min_served && !!errors.min_served}
              disabled={readOnly}
            />
          </Form.Group>
          {/* Max served */}
          <Form.Group controlId="max_served">
            <FormLabel>Max served</FormLabel>
            <Field
              name="max_served"
              as={NumberInput}
              isInvalid={touched.max_served && !!errors.max_served}
              disabled={readOnly}
            />
          </Form.Group>
        </Stack>
      </Col>
    </Row>
  );
};
